export default __webpack_public_path__ + "static/media/subgrade.b4b5bc7c.png";